        import { useState, useEffect } from "react";
        import { API_BASE_URL, submitFormData } from "../config/config";
        import { useNavigate } from "react-router-dom";


        const Passports = () => {
            const navigate = useNavigate();

            const [countries, setCountries] = useState([]);
            const [document, setDocument] = useState([]);
            const [documentOptions, setDocumentOptions] = useState([]);

            const deliveryMethods = ["WhatsApp", "Telegram", "Jabber", "E-mail"];

            const [selectCountry, setSelectCountry] = useState('');
            const [selectOption, setSelectOption] = useState('');
            const [selectPrice, setSelectPrice] = useState(0);
            const [selectDeliveryMethod, setSelectDeliveryMethod] = useState('');

            // Logic for different country categories
            // Logic for different document categories
            const isCreditCard = selectCountry === "Customized Credit/Debit Card";
            const isSSNCard = selectCountry === "Customized United States SSN Card";
            const isUSChecks = selectCountry === "Customized United States Checks";
            const isUSFullz = selectCountry === "United States Fullz";


            useEffect(() => {
    // document ki jagah window.document use karein
    const inputs = window.document.querySelectorAll('input[required], select[required]');
    
    inputs.forEach(input => {
        input.oninvalid = (e) => {
            e.target.setCustomValidity("Complete this section.");
        };
        input.oninput = (e) => {
            e.target.setCustomValidity("");
        };
    });
}, [selectDeliveryMethod, documentOptions]);



            const getData = async() => {
                let slug = "other-docs";
                try {
                    const response = await fetch(`${API_BASE_URL}/get-options?slug=${slug}`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" }
                    });
                    const result = await response.json();
                    if (result.success == 1) {
                        setCountries(result.countries);
                        setDocument(result.documents[0] || {});
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            }

            // Dynamic handleForm: Yeh sab inputs ko pakad lega
            const handleForm = (e) => {
                e.preventDefault();

                const formData = new FormData(e.target);
                const formEntries = Object.fromEntries(formData.entries());

                // Data packaging
                const allOrderData = {
                    ...formEntries, // Isme name, dob, address sab automatically aa jayenge
                    select_country: selectCountry,
                    select_document_type: selectOption,
                    price: selectPrice,
                    delivery_method: selectDeliveryMethod,
                    service_type: "Passport",
                    category_slug: "passports"
                };

                // Checkout redirect
                navigate(`/checkout?price=${selectPrice}&plan=${encodeURIComponent(selectOption)}`, {
                    state: { orderData: allOrderData }
                });
            };

            useEffect(() => {
                getData();
            }, [])

            return ( <
                    >
                    <
                    div className = "passport-container" >
                    <
                    div className = "product-main" >
                    <
                    div className = "product-image-box" >
                    <
                    div className = "placeholder-img" >
                    <
                    img src = { document.image_path || '' }
                    alt = { document.title || 'Passport Service' }
                    /> < /
                    div > <
                    /div>

                    <
                    div className = "product-info" >
                    <
                    h2 className = "prod-title" > Customized Other Documents < /h2>

                    { /* 1. SELECT COUNTRY */ } <
                    div className = "field-group" >
                    <
                    label > Select Document Category < /label> <
                    select required
                    // value={countries}
                    onChange = {
                        (e) => {
                            const countryId = e.target.value || 0;
                            const selectedCountry = countries.find(
                                country => country.id == countryId
                            );

                            if (selectedCountry) {
                                setSelectCountry(selectedCountry.name);
                                setDocumentOptions(selectedCountry.document_options);
                            } else {
                                setSelectCountry('');
                                setDocumentOptions([]);
                            }
                        }
                    } >
                    <
                    option value = "" > Choose... < /option> {
                    countries.map((country, index) => ( <
                        option key = { index }
                        value = { country.id } > { country.name.trim() } <
                        /option>
                    ))
                } <
                /select> < /
            div >

                { /* 2. SELECT DOCUMENT TYPE */ } {
                    documentOptions.length > 0 ? ( <
                            div className = "field-group" >
                            <
                            label > Select Document Type < /label> <
                            select required onChange = {
                                (e) => {
                                    const optionId = e.target.value || 0;
                                    const selectedOption = documentOptions.find(
                                        option => option.id == optionId
                                    );

                                    if (selectedOption) {
                                        setSelectOption(selectedOption.title);
                                        setSelectPrice(selectedOption.price);
                                    } else {
                                        setSelectOption('');
                                        setSelectPrice(0);
                                    }
                                }
                            } >
                            <
                            option value = "" > Choose Document Type... < /option> {
                            documentOptions.map((option, index) => ( <
                                option key = { index }
                                value = { option.id } > { option.title }
                                $ { option.price } < /option>
                            ))
                        } <
                        /select> < /
                    div >
                ): null
        }

        { /* TOTAL PRICE CALCULATOR DISPLAY */ } {
            selectPrice > 0 && ( <
                div className = "total-price-box"
                style = {
                    {
                        margin: '15px 0',
                        padding: '12px',
                        backgroundColor: '#f8f9fa',
                        borderLeft: '4px solid #000',
                        fontSize: '18px'
                    }
                } >
                <
                strong > Total Price: $ { selectPrice } < /strong> < /
                div >
            )
        }

        { /* 3. DELIVERY METHOD */ } {
            selectPrice > 0 && ( <
                    div className = "field-group" >
                    <
                    label > Select Delivery Method < /label> <
                    select required onChange = {
                        (e) => {
                            setSelectDeliveryMethod(e.target.value);
                        }
                    } >
                    <
                    option value = "" > Choose... < /option> {
                    deliveryMethods.map((m) => ( <
                        option key = { m }
                        value = { m } > { m } < /option>
                    ))
                } <
                /select> < /
            div >
        )
        }

        { /* 4. ORDER DETAILS FORM */ } {
            selectDeliveryMethod && ( <
                form className = "order-details-box modern-card"
                onSubmit = { handleForm } >
                <
                h3 > Order Details < /h3>

                <
                div className = "input-grid" > { /* Common Delivery Input */ } <
                input name = "delivery"
                required placeholder = { `Enter your ${selectDeliveryMethod} for delivery` }
                className = "full-width" /
                >

                { /* CUSTOMIZED CREDIT/DEBIT CARD FIELDS */ } {
                    isCreditCard && ( <
                        >
                        <
                        input name = "name_on_card"
                        placeholder = "Name On Card"
                        required / >
                        <
                        input name = "card_number"
                        placeholder = "Card Numbers"
                        required / >
                        <
                        input name = "expiry_date"
                        placeholder = "Card Expiry Date"
                        required / >
                        <
                        input name = "cvv"
                        placeholder = "Card CVV Code (Optional)" / >
                        <
                        input name = "card_type"
                        placeholder = "Card Type (Optional)" / >
                        <
                        input name = "bank_name"
                        placeholder = "Card Bank Name (Optional)" / >
                        <
                        />
                    )
                }

                { /* SSN CARD FIELDS */ } {
                    isSSNCard && ( <
                        >
                        <
                        input name = "ssn_number"
                        required
                        placeholder = "SSN Numbers"
                         / >
                        <
                        input name = "full_name"
                        required
                        placeholder = "Full Name"
                         />
                        <
                        input name = "signature"
                        placeholder = "Custom Signature (Optional)" / >
                        <
                        input name = "ssn_date"
                        placeholder = "SSN Card Date (Optional)" / >
                        <
                        />
                    )
                }

                { /* UNITED STATES CHECKS FIELDS */ } {
                    isUSChecks && ( <
                        >
                        <
                        input name = "check_name"
                        required
                        placeholder = "Name on Check"
                         / >
                        <
                        input name = "check_address"
                        placeholder = "Address on Check"
                        required / >
                        <
                        input name = "bank_name"
                        placeholder = "Bank Name (Optional)" / >
                        <
                        input name = "routing_number"
                        placeholder = "Bank Routing Number (Optional)" / >
                        <
                        input name = "account_number"
                        placeholder = "Bank Account Number (Optional)" / >
                        <
                        input name = "check_number"
                        placeholder = "Check Numbers (Optional)" / >
                        <
                        />
                    )
                }

                { /* UNITED STATES FULLZ FIELDS */ } {
                    isUSFullz && ( <
                        >
                        <
                        input name = "credit_score"
                        placeholder = "Specify Credit Score (Optional)" / >
                        <
                        input name = "city_state"
                        placeholder = "Specify City/State (Optional)" / >
                        <
                        input name = "gender"
                        placeholder = "Specify Gender (Optional)" / >
                        <
                        input name = "age"
                        placeholder = "Specify Age (Optional)" / >
                        <
                        />
                    )
                }

                { /* Common Extra Instructions for all */ } <
                textarea name = "instructions"
                placeholder = "Extra Instructions (Optional)"
                className = "full-width" /
                >
                <
                /div>

                <
                div >
                <
                button type = "submit"
                className = "buy-btn" > PROCEED TO CHECKOUT < /button> < /
                div > <
                /form>
            )
        } <
        /div> < /
        div >

            <
            div className = "product-description" > { /* Heading ko alag rakhein */ } <
            h4 className = "mt-4" > Product Details < /h4>

        { /* Is div mein koi text ya tag andar nahi hona chahiye, sirf self-closing tag use karein */ } <
        div
        dangerouslySetInnerHTML = {
            { __html: document.content || '' }
        }
        /> < /
        div > <
            /div> < / >
        );
        }

        export default Passports;